module.exports = __webpack_public_path__ + "img/1.58b917fa.jpg";